export function createArray (length, iterator = i => i) {
  return (new Array(length))
    .fill(null)
    .map((_, index) => iterator(index))
}

export function shuffleArray (array) {
  return array.slice().sort(() => Math.random() - 0.5)
}
